import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import Footer from "./Component/Footer";
import { useState } from "react";
import { publicInquiryAPI } from "../services/api";
import "./Contact.css";


// Inquiry types — must match the Admin Portal FORM_TYPES codes so submissions
// can be filtered correctly in Inquiry Management.
const INQUIRY_TYPES = [
    { code: "CONTACT", label: "Contact" },
    { code: "GENERAL_INQUIRY", label: "General Inquiry" },
    { code: "CLASS_INQUIRY", label: "Class Inquiry" },
    { code: "EVENT_INQUIRY", label: "Event Inquiry" },
    { code: "VOLUNTEER", label: "Volunteer" },
    { code: "NEWSLETTER", label: "Newsletter" },
];

const Contact = () => {
    const initialForm = { inquiryType: "CONTACT", name: "", email: "", phone: "", subject: "", message: "", website: "" };
    const [form, setForm] = useState(initialForm);
    const [submitting, setSubmitting] = useState(false);
    const [feedback, setFeedback] = useState(null); // { type: 'success' | 'error', text: string }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFeedback(null);

        // Basic client-side validation (server validates authoritatively too)
        if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
            setFeedback({ type: "error", text: "Please fill in your name, email, and message." });
            return;
        }

        setSubmitting(true);
        const result = await publicInquiryAPI.submitContact({
            websiteCode: "YUGALKUNJ",
            formType: form.inquiryType || "CONTACT",
            name: form.name.trim(),
            email: form.email.trim(),
            phone: form.phone.trim(),
            subject: form.subject.trim(),
            message: form.message.trim(),
            pageUrl: typeof window !== "undefined" ? window.location.href : "",
            website: form.website, // honeypot — must stay empty
        });
        setSubmitting(false);

        if (result.success) {
            setFeedback({ type: "success", text: result.message || "Thank you! Your message has been submitted successfully." });
            setForm(initialForm);
        } else {
            setFeedback({ type: "error", text: result.message || "Unable to submit your request. Please try again later." });
        }
    };

    return (
        <>



            <MenuBar />
            <Sidebar />
            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Contact US" current="Get In Touch" />





            {/* <!--Contact Section (modern redesign)--> */}
            <section className="yk-contact">
                <div className="yk-container">

                    <div className="yk-head">
                        <span className="yk-eyebrow"><span className="fa fa-dove"></span> We'd love to hear from you</span>
                        <h2>Get In <span>Touch!</span></h2>
                        <p>Have a question about our programs, events, or how to get involved? Send us a message and a member of the Yugal Kunj family will reach out to you.</p>
                    </div>

                    <div className="yk-grid">
                        {/* Form card */}
                        <div className="yk-card">
                            <div className="yk-card-title">Send us a message</div>
                            <div className="yk-card-sub">Fill in the details below — we usually respond within 1–2 business days.</div>

                            <form method="post" id="contact-form" onSubmit={handleSubmit} noValidate>
                                <div className="yk-form-grid">
                                    <div className="yk-field yk-col-2">
                                        <label htmlFor="inquiryType">Inquiry Type</label>
                                        <select id="inquiryType" className="yk-select" name="inquiryType" value={form.inquiryType} onChange={handleChange} required>
                                            {INQUIRY_TYPES.map((t) => (
                                                <option key={t.code} value={t.code}>{t.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="yk-field">
                                        <label htmlFor="name">Your Name<span className="yk-req">*</span></label>
                                        <input id="name" className="yk-input" type="text" name="name" value={form.name} onChange={handleChange} placeholder="e.g. Radha Sharma" required />
                                    </div>

                                    <div className="yk-field">
                                        <label htmlFor="email">Email<span className="yk-req">*</span></label>
                                        <input id="email" className="yk-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" required />
                                    </div>

                                    <div className="yk-field">
                                        <label htmlFor="phone">Phone</label>
                                        <input id="phone" className="yk-input" type="text" name="phone" value={form.phone} onChange={handleChange} placeholder="(678) 920-6669" />
                                    </div>

                                    <div className="yk-field">
                                        <label htmlFor="subject">Subject</label>
                                        <input id="subject" className="yk-input" type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="How can we help?" />
                                    </div>

                                    <div className="yk-field yk-col-2">
                                        <label htmlFor="message">Message<span className="yk-req">*</span></label>
                                        <textarea id="message" className="yk-textarea" name="message" value={form.message} onChange={handleChange} placeholder="Write your message here..." required></textarea>
                                    </div>

                                    {/* Honeypot anti-spam field — hidden from real users, must stay empty */}
                                    <div style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }} aria-hidden="true">
                                        <label>Do not fill this field
                                            <input type="text" name="website" tabIndex="-1" autoComplete="off" value={form.website} onChange={handleChange} />
                                        </label>
                                    </div>

                                    {feedback && (
                                        <div className={`yk-alert ${feedback.type === 'success' ? 'yk-alert-success' : 'yk-alert-error'}`}>
                                            <span className="yk-dot"></span>
                                            <span>{feedback.text}</span>
                                        </div>
                                    )}

                                    <button className="yk-submit" type="submit" name="submit-form" disabled={submitting}>
                                        {submitting ? 'Sending...' : 'Send Message'}
                                        {!submitting && <span className="yk-arrow fa fa-arrow-right"></span>}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Aside: image + quick facts */}
                        <aside className="yk-aside">
                            <div className="yk-photo">
                                <img src="https://stssevastorage.blob.core.windows.net/ykwebsite/resource/featured-image-3.jpg" alt="Yugal Kunj community" />
                                <div className="yk-photo-badge">
                                    <strong>Seva with a smile</strong>
                                    Serving the community with love &amp; devotion.
                                </div>
                            </div>

                            <div className="yk-quick">
                                <h4>Reach us directly</h4>
                                <div className="yk-quick-item">
                                    <div className="yk-ic"><span className="fa fa-map-marker-alt"></span></div>
                                    <div>
                                        <div className="yk-qt">Visit us</div>
                                        <div className="yk-qv">2769 Duluth Hwy, Duluth, GA 30096</div>
                                    </div>
                                </div>
                                <div className="yk-quick-item">
                                    <div className="yk-ic"><span className="fa fa-phone-alt"></span></div>
                                    <div>
                                        <div className="yk-qt">Call us</div>
                                        <div className="yk-qv"><a href="tel:678-920-6669">678-920-6669</a></div>
                                    </div>
                                </div>
                                <div className="yk-quick-item">
                                    <div className="yk-ic"><span className="fa fa-envelope-open"></span></div>
                                    <div>
                                        <div className="yk-qt">Email us</div>
                                        <div className="yk-qv"><a href="mailto:info@yugalkunj.org">info@yugalkunj.org</a></div>
                                    </div>
                                </div>
                                <div className="yk-quick-item">
                                    <div className="yk-ic"><span className="fa fa-clock"></span></div>
                                    <div>
                                        <div className="yk-qt">Open hours</div>
                                        <div className="yk-qv">Every Day · 7:00 AM – 8:50 PM</div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>

                    {/* Location cards */}
                    <div className="yk-locations">
                        <div className="yk-loc-head">
                            <h3>Our Centers</h3>
                            <p>Connect with a Yugal Kunj center near you.</p>
                        </div>

                        <div className="yk-loc-grid">
                            {/* Location — Duluth, GA */}
                            <div className="yk-loc v-green">
                                <div className="yk-loc-top">
                                    <span className="yk-flag"><span className="fa fa-map-marker-alt"></span> USA</span>
                                    <h4>Yugal Kunj</h4>
                                </div>
                                <div className="yk-loc-body">
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-map-marker-alt"></span></div><span>2769 Duluth Hwy Duluth, GA 30096</span></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-phone-alt"></span></div><a href="tel:678-920-6669">678-920-6669</a></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-envelope-open"></span></div><a href="mailto:info@yugalkunj.org">info@yugalkunj.org</a></div>
                                </div>
                                <div className="yk-social">
                                    <a href="https://www.facebook.com/yugalkunj/" target="_blank" rel="noreferrer"><span className="fab fa-facebook-f"></span></a>
                                    <a href="https://twitter.com/search?q=yugalkunj" target="_blank" rel="noreferrer"><span className="fab fa-twitter"></span></a>
                                    <a href="https://www.yelp.com/biz/yugal-kunj-duluth-2" target="_blank" rel="noreferrer"><span className="fab fa-yelp"></span></a>
                                    <a href="https://www.instagram.com/yugal_kunj/" target="_blank" rel="noreferrer"><span className="fab fa-instagram"></span></a>
                                    <a href="https://video.search.yahoo.com/search/video;_ylt=AwrC1DGkf51cEi8A_gzQtDMD;_ylu=X3oDMTB0N2Noc21lBGNvbG8DYmYxBHBvcwMxBHZ0aWQDBHNlYwNwaXZz?p=yugal+kunj+duluth+ga&amp;fr2=piv-web&amp;fr=yfp-t-s" target="_blank" rel="noreferrer"><span className="fab fa-yahoo"></span></a>
                                </div>
                            </div>

                            {/* Location — Milwaukee, WI */}
                            <div className="yk-loc v-teal">
                                <div className="yk-loc-top">
                                    <span className="yk-flag"><span className="fa fa-map-marker-alt"></span> Wisconsin</span>
                                    <h4>Shyama Shyam Dham<br />Milwaukee, Wisconsin</h4>
                                </div>
                                <div className="yk-loc-body">
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-map-marker-alt"></span></div><span>W173 N9170 St Francis Dr. Suite 12, Menomonee Falls WI, 53051</span></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-phone-alt"></span></div><a href="tel:262-252-7185">(262) 252-7185</a></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-envelope-open"></span></div><span><a href="mailto:deepti_dhingra@yahoo.com">Deepti</a> or <a href="mailto:anoop_dhingra@yahoo.com">Anoop Dhingra</a></span></div>
                                </div>
                                <div className="yk-social">
                                    <a href="#"><span className="fab fa-facebook-f"></span></a>
                                    <a href="#"><span className="fab fa-twitter"></span></a>
                                    <a href="#"><span className="fab fa-vimeo-v"></span></a>
                                    <a href="#"><span className="fab fa-instagram"></span></a>
                                    <a href="#"><span className="fab fa-youtube"></span></a>
                                </div>
                            </div>

                            {/* Location — Toronto, Canada */}
                            <div className="yk-loc v-gold">
                                <div className="yk-loc-top">
                                    <span className="yk-flag"><span className="fa fa-map-marker-alt"></span> Canada</span>
                                    <h4>Yugalkunj Toronto Canada</h4>
                                </div>
                                <div className="yk-loc-body">
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-map-marker-alt"></span></div><span>375 Aberdeen Ave, Hamilton, ON L8P 2R7, Canada</span></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-phone-alt"></span></div><a href="tel:+15194042331">+1 (519) 404-2331</a></div>
                                    <div className="yk-loc-row"><div className="yk-ic"><span className="fa fa-envelope-open"></span></div><a href="mailto:canadainfo@yugalkunj.org">canadainfo@yugalkunj.org</a></div>
                                </div>
                                <div className="yk-social">
                                    <a href="#"><span className="fab fa-facebook-f"></span></a>
                                    <a href="#"><span className="fab fa-twitter"></span></a>
                                    <a href="#"><span className="fab fa-vimeo-v"></span></a>
                                    <a href="#"><span className="fab fa-instagram"></span></a>
                                    <a href="#"><span className="fab fa-youtube"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map */}
                    <div className="yk-map-wrap">
                        <iframe
                            title="Yugal Kunj Location Map"
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6616.706205168105!2d-84.12566100000001!3d33.983463!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a2e90fd1f963%3A0x1ec46d89ce53332c!2s2769%20Duluth%20Hwy%2C%20Duluth%2C%20GA%2030096!5e0!3m2!1sen!2sus!4v1589379025209!5m2!1sen!2sus"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>

                </div>
            </section>
            {/* <!--End Contact Section--> */}
            <Footer />




        </>

    )


}

export default Contact;
